module.exports = __webpack_public_path__ + "img/eductor_stopped.387ba724.svg";